import { render } from "./PersonDetail.vue?vue&type=template&id=5277c05c&scoped=true"
import script from "./PersonDetail.vue?vue&type=script&lang=js"
export * from "./PersonDetail.vue?vue&type=script&lang=js"

import "./PersonDetail.vue?vue&type=style&index=0&id=5277c05c&scoped=true&lang=less"

import exportComponent from "D:\\workCode\\cbc\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5277c05c"]])

export default __exports__